import { WATER_IMG_PRE_PATH, MED_IMG_PRE_PATH, GROUP_IMG_PRE_PATH, GOV_IMG_PRE_PATH, LINK_PRE_PATH } from './index';

export const headBg = WATER_IMG_PRE_PATH + 'pc/d52614b366772dd082febf6d3f622a4d185c2a458cbf9a448cc2eee23709581e.jpg';
export const headBgM = WATER_IMG_PRE_PATH + 'm/b29218614761d55491d5a369e90bd1fabb59aa558c39224fe459c358237360fb.jpg';
export const frameSrc = WATER_IMG_PRE_PATH + 'pc/b7ddbdd7f17c85ad4978a903cffa5c9f8a512de4420eeda7719faf16e7cefb05.jpg';
export const frameSrcM = WATER_IMG_PRE_PATH + 'm/ef853ce81460156091a6d53e8a844791ff80e37e67a5071263c197737178bc8f.jpg';

export const challenge = [
  {
    icon: WATER_IMG_PRE_PATH + 'pc/9be7f243c14922c4551667a115b4011fa2ed413c7d861cdec8604924de71dd30.png',
    title: '系统相对分散，制约业务决策效率',
    desc: '水务系统复杂、流程长、环节多，亟需推进数字孪生水利工程建设，提升业务决策效率',
  },
  {
    icon: WATER_IMG_PRE_PATH + 'pc/c91e24168ee0dcfda7bceead76fadcae6ff88f1f45215a55384c61adf095ea39.png',
    title: '业务路径繁琐，场景应用难拓展',
    desc: '除视频会议、日常监管、业务培训、汛期演练外，亟需深入水利业务流程拓展场景应用',
  },
  {
    icon: WATER_IMG_PRE_PATH + 'pc/7840349f8c91dc09a6dca94444a46e1181a480eb770fdd20e0f6c9dd8c7181b4.png',
    title: '网络环境复杂，信息难以直达一线',
    desc: '水利业务网络环境复杂，需保障信息从指挥中心直达一线基层，强化防汛指挥调度能力',
  },
  {
    icon: WATER_IMG_PRE_PATH + 'pc/0167dac9f63886be9672a379ddcdcb4aa9204c9230eeec4b2b1e423b7c100a44.png',
    title: '旧系统设备不一，孤岛式应用',
    desc: '水利业务系统设备基础各异，难以实现高效互联互通，存在数据分散、投入运维成本高等问题',
  },
];
export const frame = [
  {
    title: '高效视频协同',
    icon: GOV_IMG_PRE_PATH + 'pc/bfb3d4b4b4b6729fa3595f0fc4c1ebb598a04a7d88399377c7eebc230cd20d0f.png',
  },
  {
    title: '嵌入业务场景',
    icon: GROUP_IMG_PRE_PATH + 'pc/755d6bc43121cef1bdeb80dbbab62bc8755abd23da0beac56f5c2f3e14c7193b.png',
  },
  {
    title: '信息直达一线',
    icon: WATER_IMG_PRE_PATH + 'pc/b09b8f2318f42e1199552e8ba1712cecc1d57c01a5bf609235f1698ae62c7a3a.png',
  },
  {
    title: '设备兼容利旧',
    icon: GROUP_IMG_PRE_PATH + 'pc/1efd342155c574e9a0f7fa8c701863d275ed69f43b8f446402cf3ab34abc2e39.png',
  },
];
export const advantage = [
  {
    icon: MED_IMG_PRE_PATH + 'm/7ea5a8941cc1eda63537c9577c2a931742522ce4c1654e5be92f3e04b41942f4.png',
    title: '大规模并发',
    desc: '运营级集群架构，灵活部署，按需弹性扩展，具有超大规模接入能力，有效形成“水利部-省-市-县-乡-村”六级联动',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/ba7fb7ba0a0f40557012ce829250051134a7fa360fd790dde54e3b843ca4fa6a.png',
    title: '高安全保密',
    desc: '全自研底层技术，国密算法端到端全链路加密，架构级安全保障，通过等保三级2.0+可信云双重安全资质认证',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/0c61ed2215d72793a025f868960559d79e32f8736569b0be67c1f23132891983.png',
    title: '超高清体验',
    desc: '全自研底层技术，具备完全自主核心知识产权，“云+端”国产化软硬件方案有效保障1080P/4K超高清体验',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/7a10983c134bfdc2a3fc06764228285a7976f145d399623699e963f6ae1144f9.png',
    title: '全场景覆盖',
    desc: '覆盖防汛抗旱指挥中心、大中小会议室、桌面、移动端、无人机等各类型终端，可灵活接入内外网、水利专网、互联网、4G/5G等多网络环境',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/38dce2824d488c5ae758fce697cff2ea0c3ac160ed624d6a1be2eceae25be60b.png',
    title: '超融合应用',
    desc: '实现水利视频会议、水利监控、直播、录播、数据、语音融合互通，统一媒体接入能力，支撑多种水利业务应用',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/6168c4ec4c0a7e0c82929cfbc66642c110409b54265fd059e84212c0d45af7e7.png',
    title: '开放式集成',
    desc: '全面开放API/SDK，深度融合水利业务场景，如打造智慧水利“一张图”、接入各类移动办公系统等',
  },
];
export const scene = [
  {
    title: '防汛指挥',
    desc: '支持指挥中心与一线实时沟通，通过可视化调度让防汛指令实现快速传达与落实',
    pcUrl: WATER_IMG_PRE_PATH + 'pc/3bd79bd2220c4f18cce31ba0f1f09af71864fda3877d231fa8f3292f005d6222.jpg',
  },
  {
    title: '巡河巡湖',
    desc: '通过手机、无人机等终端将现场监控回传中心，保障水利巡查工作无死角开展',
    pcUrl: WATER_IMG_PRE_PATH + 'pc/e8bd519fb21f7990ccc46da1d76a0d0c5ba325bca5a2e4436f1982eae7741c0c.jpg',
  },
  {
    title: '河长督查',
    desc: '实现跨部门多级联动，现场巡查与远程督查相结合，让督查更便捷，考核更高效',
    pcUrl: WATER_IMG_PRE_PATH + 'pc/4ee4fc98dce2730fafceace6da7f47ef613188e69759316bb3754c6041fa9794.jpg',
  },
  {
    title: '值班点名',
    desc: '指挥中心对防汛抗旱值班室、水库等单位进行24小时画面监看和日常值班点名',
    pcUrl: WATER_IMG_PRE_PATH + 'pc/e390f2d9b842baf8ef86def96b6711657607fa60675c765d4ca959e4643e45b0.jpg',
  },
  {
    title: '协同调度',
    desc: '支持跨部门协同指挥高效开展，如汛期期间，可快速连线中国气象局、地震局等组织',
    pcUrl: WATER_IMG_PRE_PATH + 'pc/613f578a77dd7ed320aa266f5df04cede8f881ecc28728b678e7b4a30554b0f4.jpg',
  },
  {
    title: '水文监测',
    desc: '结合无人机、智能终端等设备，对突发性水量变化和水体污染实时监测与预警',
    pcUrl: WATER_IMG_PRE_PATH + 'pc/41fb7eedab66b3233b109e84792e17e9ff12e72542bd069506f90313edc28eb2.jpg',
  },
];
export const caseList = [
  [
    {
      logo: WATER_IMG_PRE_PATH + 'a549baadbdd62dc5749c481dfc0871957074fbc11e62875bee990141a29f0a7a.jpg',
      title: '水利部',
      desc: '中华人民共和国水利部（以下简称“水利部”）按照“需求牵引、应用至上、数字赋能、提升能力”的数字化转型要求，携手小鱼易连打造全信创的水利部指挥调度云视频系统，实现纵向覆盖部-省-市-县四级单位，横向打通相关政府业务单位和部门，满足水利部防汛应急指挥、日常会议会商、远程督查等场景的广泛应用，助力水利治理、防汛抗旱等云上协同管理，全面推进智慧水利建设。',
      link: LINK_PRE_PATH + 'd03aba',
    },
    {
      logo: WATER_IMG_PRE_PATH + 'pc/a3ed4853d678ef2bdf4915e47a0f5ffabcc58326a37285dd69788362a3568198.png',
      title: '水利部黄河水利委员会',
      desc: '水利部黄河水利委员会运用小鱼易连云视频，实现了危机情况下的实时防汛指挥、应急指挥、日常工作会议、上传下达、基层党建等应用，全程保障了防洪调度工作的高效开展，令决策、指挥、调度、实施各环节的运转高效流畅，让黄河流域的水资源保护、水域岸线管理、水污染防治、水环境治理等工作开展提升了效率。',
      link: LINK_PRE_PATH + '1010',
    },
    {
      logo: WATER_IMG_PRE_PATH + 'pc/8e1a23a4b9c88de504f22c1acc091321b15434c0698e5b077b904c7017ae8a20.png',
      title: '长沙市水文局',
      desc: '长沙市水文局携手小鱼易连建设可视化应急系统，下辖城区、长沙县、浏阳市、宁乡县4个县级水文水资源局，以及505个管理站点，高效实现多方协调、灵活调度，为指挥中心、一线人员建立实时互动沟通通道，全面助力长沙水文中心数字化创新变革。目前在各个应用场景的科技赋能，能够迅速提升自然灾害、突发事件响应速度，加强水资源管理和监管，大幅提高突发事件处理能力。',
      link: LINK_PRE_PATH + '1038',
    },
  ],
];
